<proffeo-industries-list
  (editIndustry)="openEditCompanyIndustryDialog($event)"
  (deleteIndustry)="openCompanyIndustryDeleteConfirmationDialog($event)"
  [industries]="companyIndustries()"
></proffeo-industries-list>
